import React from 'react';

export default ({ color = '#375a8c' }) => (
  <svg viewBox="0 0 1041.32 554.17">
    <defs>
      <linearGradient
        id="dff037aa-d578-4bab-81e7-399360663117"
        x1="597.75"
        y1="725.44"
        x2="597.75"
        y2="347.69"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="gray" stopOpacity="0.25" />
        <stop offset="0.54" stopColor="gray" stopOpacity="0.12" />
        <stop offset="1" stopColor="gray" stopOpacity="0.1" />
      </linearGradient>
    </defs>
    <title>programming</title>
    <path
      d="M1040.82,611.12q-1.74,3.75-3.47,7.4-2.7,5.67-5.33,11.12c-.78,1.61-1.56,3.19-2.32,4.77-8.6,17.57-16.63,33.11-23.45,45.89A73.21,73.21,0,0,1,942.44,719l-151.65,1.65h-1.6l-13,.14-11.12.12-34.1.37-1.38,0-17.36.19h-.53l-107,1.16-95.51,1-11.11.12-69,.75H429l-44.75.48h-.48l-141.5,1.53-42.33.46a88.07,88.07,0,0,1-26.67-3.82,86.39,86.39,0,0,1-39.09-24.75C116,678.37,102.75,655,93.85,629.64q-1.93-5.49-3.6-11.12C59.44,514.37,97,380,164.6,290.08q4.25-5.64,8.64-11l.07-.08c20.79-25.52,44.1-46.84,68.93-62,44-26.91,92.75-34.49,140.7-11.9,40.57,19.12,78.45,28.11,115.17,30.55,3.71.24,7.42.42,11.11.53,84.23,2.65,163.17-27.7,255.87-47.29,3.69-.78,7.39-1.55,11.12-2.28,66.13-13.16,139.49-20.1,226.73-5.51a189.09,189.09,0,0,1,26.76,6.4q5.77,1.86,11.12,4c41.64,16.94,64.35,48.24,74,87.46q1.37,5.46,2.37,11.11C1134.3,384.41,1084.19,518.23,1040.82,611.12Z"
      transform="translate(-79.34 -172.91)"
      fill={color}
      opacity="0.1"
    />
    <g opacity="0.1">
      <path
        d="M242.24,217V726.62l-42.33.46a88.07,88.07,0,0,1-26.67-3.82V279h.07C194.1,253.45,217.41,232.13,242.24,217Z"
        transform="translate(-79.34 -172.91)"
        fill={color}
      />
      <path
        d="M1117.24,290.08H164.6q4.25-5.64,8.64-11V279h941.63Q1116.24,284.43,1117.24,290.08Z"
        transform="translate(-79.34 -172.91)"
        fill={color}
      />
      <path
        d="M1040.82,191.51v427h-3.47q-2.7,5.67-5.33,11.12c-.78,1.61-1.56,3.19-2.32,4.77V187.47Q1035.47,189.33,1040.82,191.51Z"
        transform="translate(-79.34 -172.91)"
        fill={color}
      />
      <path
        d="M776.21,186.58V720.83l-11.12.12V188.86C768.78,188.08,772.48,187.31,776.21,186.58Z"
        transform="translate(-79.34 -172.91)"
        fill={color}
      />
      <path
        d="M509.22,236.15V723.73l-11.11.12V235.62C501.82,235.86,505.53,236,509.22,236.15Z"
        transform="translate(-79.34 -172.91)"
        fill={color}
      />
      <path
        d="M1037.35,618.52q-2.7,5.67-5.33,11.12H93.85q-1.93-5.49-3.6-11.12Z"
        transform="translate(-79.34 -172.91)"
        fill={color}
      />
    </g>
    <rect x="211.6" y="265.83" width="19" height="57.66" fill="#3f3d56" />
    <rect x="722.93" y="262.83" width="19" height="61" fill="#3f3d56" />
    <polygon
      points="863.1 533.65 863.1 546.65 711.18 548.05 709.56 548.08 651.82 548.61 650.44 548.63 632.89 548.78 632.37 548.78 525.39 549.77 349.78 551.4 349.63 551.4 304.98 551.82 304.5 551.83 106.1 553.65 106.1 538.65 152.75 510.65 246.35 509.87 248.35 509.86 249.01 509.85 251.01 509.82 295.95 509.45 297.96 509.44 298.6 509.43 300.6 509.42 315.01 509.3 315.39 509.29 350.94 508.99 351.23 508.99 628.63 506.65 635.42 506.6 636.1 506.6 641.28 506.55 678.93 506.24 680.93 506.21 682.78 506.19 683.74 506.19 695.45 506.1 697.77 506.07 700.88 506.05 710.63 505.96 726.1 505.83 728.1 505.81 731.58 505.79 732.23 505.79 806.94 505.15 863.1 533.65"
      fill="#65617d"
    />
    <polygon
      points="863.1 533.65 863.1 546.65 711.18 548.05 709.56 548.08 651.82 548.61 650.44 548.63 632.89 548.78 632.37 548.78 525.39 549.77 349.78 551.4 349.63 551.4 304.98 551.82 304.5 551.83 106.1 553.65 106.1 538.65 152.75 510.65 246.35 509.87 248.35 509.86 249.01 509.85 251.01 509.82 295.95 509.45 297.96 509.44 298.6 509.43 300.6 509.42 315.01 509.3 315.39 509.29 350.94 508.99 351.23 508.99 628.63 506.65 635.42 506.6 636.1 506.6 641.28 506.55 678.93 506.24 680.93 506.21 682.78 506.19 683.74 506.19 695.45 506.1 697.77 506.07 700.88 506.05 710.63 505.96 726.1 505.83 728.1 505.81 731.58 505.79 732.23 505.79 806.94 505.15 863.1 533.65"
      opacity="0.2"
    />
    <path
      d="M375.44,656.57v24.49a6.13,6.13,0,0,1-3.5,5.54,6,6,0,0,1-2.5.6l-34.9.74a6,6,0,0,1-2.7-.57,6.12,6.12,0,0,1-3.57-5.57V656.57Z"
      transform="translate(-79.34 -172.91)"
      fill="#3f3d56"
    />
    <path
      d="M375.44,656.57v24.49a6.13,6.13,0,0,1-3.5,5.54,6,6,0,0,1-2.5.6l-34.9.74a6,6,0,0,1-2.7-.57,6.12,6.12,0,0,1-3.57-5.57V656.57Z"
      transform="translate(-79.34 -172.91)"
      opacity="0.1"
    />
    <path
      d="M377.44,656.57v24.49a6.13,6.13,0,0,1-3.5,5.54,6,6,0,0,1-2.5.6l-34.9.74a6,6,0,0,1-2.7-.57,6.12,6.12,0,0,1-3.57-5.57V656.57Z"
      transform="translate(-79.34 -172.91)"
      fill="#3f3d56"
    />
    <rect x="680.93" y="483.66" width="47.17" height="31.5" fill="#3f3d56" />
    <rect x="680.93" y="483.66" width="47.17" height="31.5" opacity="0.1" />
    <rect x="678.93" y="483.66" width="47.17" height="31.5" fill="#3f3d56" />
    <polygon
      points="230.6 265.82 230.6 271.55 211.6 271.06 211.6 265.82 230.6 265.82"
      opacity="0.1"
    />
    <path
      d="M435,277.31l-22.83,164a4.3,4.3,0,0,1-4.37,3.71L225,440.28l-3.47-.09a4.3,4.3,0,0,1-4.16-4.87L243,263.64a4.3,4.3,0,0,1,4.54-3.63L431,272.43A4.29,4.29,0,0,1,435,277.31Z"
      transform="translate(-79.34 -172.91)"
      fill="#65617d"
    />
    <polygon
      points="175.93 99.16 156.6 250.49 324.6 255.82 345.26 109.82 175.93 99.16"
      fill={color}
    />
    <rect x="384.6" y="96.82" width="204.67" height="173.33" rx="5.33" ry="5.33" fill="#65617d" />
    <rect x="394.26" y="108.49" width="186" height="144.33" fill={color} />
    <polygon
      points="741.93 262.82 741.93 266.61 722.93 267 722.93 262.82 741.93 262.82"
      opacity="0.1"
    />
    <path
      d="M907,432.53a3.08,3.08,0,0,1-3,3.28L716.8,439.68a3.08,3.08,0,0,1-3.13-2.79L697.58,269.61a3.08,3.08,0,0,1,2.92-3.37L886.28,257l2-.1a3.07,3.07,0,0,1,3.22,2.8Z"
      transform="translate(-79.34 -172.91)"
      fill="#65617d"
    />
    <polygon
      points="628.93 103.16 798.6 94.82 812.93 246.82 644.6 250.82 628.93 103.16"
      fill={color}
    />
    <path
      d="M907,432.53a3.08,3.08,0,0,1-3,3.28L886.28,257l2-.1a3.07,3.07,0,0,1,3.22,2.8Z"
      transform="translate(-79.34 -172.91)"
      opacity="0.1"
    />
    <path
      d="M247.57,260,225,440.28l-3.47-.09a4.3,4.3,0,0,1-4.16-4.87L243,263.64A4.3,4.3,0,0,1,247.57,260Z"
      transform="translate(-79.34 -172.91)"
      opacity="0.1"
    />
    <rect x="211.6" y="306.41" width="19" height="17.08" opacity="0.1" />
    <polygon
      points="298.1 483.65 298.1 488.62 250.93 489.88 250.93 483.65 298.1 483.65"
      opacity="0.1"
    />
    <path
      d="M460.69,485.27v168.2a4,4,0,0,1-3.85,3.95l-191.65,5.1h-.05a4,4,0,0,1-3.95-3.95V485.27a4,4,0,0,1,3.95-3.95h191.6A4,4,0,0,1,460.69,485.27Z"
      transform="translate(-79.34 -172.91)"
      fill="#65617d"
    />
    <path
      d="M265.19,481.32v181.2h-.05a4,4,0,0,1-3.95-3.95V485.27a4,4,0,0,1,3.95-3.95Z"
      transform="translate(-79.34 -172.91)"
      opacity="0.1"
    />
    <polygon
      points="194.6 319.15 372.1 319.15 372.1 467.4 194.6 471.4 194.6 319.15"
      fill="#d4dfec"
    />
    <rect x="722.93" y="306.41" width="19" height="17.42" opacity="0.1" />
    <polygon
      points="726.1 483.65 726.1 490.06 678.93 488.8 678.93 483.65 726.1 483.65"
      opacity="0.1"
    />
    <path
      d="M867.69,485.27v173.3a4,4,0,0,1-4,3.95h0L672,657.42a4,4,0,0,1-3.85-3.95V485.27a4,4,0,0,1,3.95-3.95h191.6A4,4,0,0,1,867.69,485.27Z"
      transform="translate(-79.34 -172.91)"
      fill="#65617d"
    />
    <path
      d="M867.69,485.27v173.3a4,4,0,0,1-4,3.95h0V481.32h0A4,4,0,0,1,867.69,485.27Z"
      transform="translate(-79.34 -172.91)"
      opacity="0.1"
    />
    <polygon
      points="775.6 319.15 598.1 319.15 598.1 467.4 775.6 471.4 775.6 319.15"
      fill="#d4dfec"
    />
    <path
      d="M663.19,485.27v168.2a4,4,0,0,1-3.85,3.95l-191.65,5.1h0a4,4,0,0,1-4-3.95V485.27a4,4,0,0,1,3.95-3.95h191.6A4,4,0,0,1,663.19,485.27Z"
      transform="translate(-79.34 -172.91)"
      fill="#65617d"
    />
    <polygon
      points="397.1 319.15 574.6 319.15 574.6 467.4 397.1 471.4 397.1 319.15"
      fill="#d4dfec"
    />
    <polygon
      points="863.1 533.65 863.1 546.65 711.18 548.05 709.56 548.08 651.82 548.61 650.44 548.63 632.89 548.78 632.37 548.78 525.39 549.77 349.78 551.4 349.63 551.4 304.98 551.82 304.5 551.83 106.1 553.65 106.1 538.65 308.61 537.32 309.09 537.32 350.08 537.04 350.27 537.04 633.35 535.17 633.64 535.17 633.81 535.16 634.28 535.16 639.07 535.13 640.53 535.13 715.02 534.63 719.42 534.61 720.4 534.6 863.1 533.65"
      opacity="0.1"
    />
    <circle cx="487.26" cy="272.16" r="51.33" fill="#fbbebe" />
    <path
      d="M383.74,725.09c0-.11.06-.23.1-.35,1-3.59,2.78-9.66,4.11-14.51.17-.6.33-1.19.48-1.75,1.47-5.47,4.33-18.28,5.92-26.27.56-2.81,1-5,1.09-6.1.2-1.69,3.21-8.92,6.62-17.23,2.39-5.84,5-12.22,6.91-17.6a61.38,61.38,0,0,0,2.93-9.85,5.1,5.1,0,0,0,0-2.13,14.69,14.69,0,0,1-.48-3.5v0c-.23-6.2,1.62-16,4.48-20.11,3.5-5,6-23.66,6-23.66s5.18.75,6-3.53a6.15,6.15,0,0,0,.1-1.4,7.41,7.41,0,0,0-.09-1.11c-.89-6.24,14.72-12.88,23.5-14.31a19.67,19.67,0,0,1,3-.28,27.24,27.24,0,0,0,6.25-1.44q1.4-.43,3-1c3.68-1.24,8.08-2.88,12.75-4.68,17.56-6.81,38.82-16,38.82-16,.15-.71.32-1.39.51-2.06a27.71,27.71,0,0,1,16.35-18.93h0c0-.66,0-1.33,0-2,0-3.45-.15-7-.3-10.54,0-.69-.06-1.38-.1-2.07,0-.2,0-.41,0-.61s0-.35,0-.52c0-.7-.07-1.4-.11-2.09l-.18-.14a16.41,16.41,0,0,1-3.9-4.2,15.27,15.27,0,0,1-1.42-3c-1.25-3.39-1.54-7.17-2.38-10.75l-.18-.74a84,84,0,0,0-4-10.58c-2.21-5.42-3.91-11-5.6-16.65q-1.54-5.13-3.11-10.28l-1.58-5.24c-.3-1-.6-2-.83-3v0a13.27,13.27,0,0,1-.26-1.4,0,0,0,0,1,0,0,10,10,0,0,1,.24-4.61,32.09,32.09,0,0,1,1.32-3,7.87,7.87,0,0,0,.5-1.38v0a3,3,0,0,0,.08-.32,5.65,5.65,0,0,0,.11-1.08,18.46,18.46,0,0,0-.52-3.89.07.07,0,0,1,0-.05,2.56,2.56,0,0,0-.05-.27,25.48,25.48,0,0,1-.36-3,28.45,28.45,0,0,1,3.47-15.57l.19-.36a25.22,25.22,0,0,1,1.84-2.78h0c.31-.42.63-.82,1-1.22-1.4,1.34-3.7.75-5-.69a3.61,3.61,0,0,1-.55-.75,3.81,3.81,0,0,1-.23-.45c-.05-.12-.09-.25-.13-.38-.7-2.45.52-5.06,2.12-7.05a18.49,18.49,0,0,1,5.74-4.7h0a3.84,3.84,0,0,1,.4-.21,17.12,17.12,0,0,1,2.64-1.06h0a15.06,15.06,0,0,1,1.63-.44l-3.71-.34-1.5-.14a14.49,14.49,0,0,1,13-10.91h1.08a11.73,11.73,0,0,1,1.57.13,4.44,4.44,0,0,1-2.65-4.33,14.41,14.41,0,0,0,9.19,3.06h.38a30,30,0,0,1-.34-3.27h0a0,0,0,0,1,0,0,0,0,0,0,1,0,0,33.19,33.19,0,0,1,0-4.46,8.44,8.44,0,0,0,6.78,2.26l-2.08-2.9a9.49,9.49,0,0,0,6.56,2.05l.48-.05a7,7,0,0,0,1.19-.23l.09,0c-.19-.24-.36-.49-.53-.75l-.06-.12a9.67,9.67,0,0,1-1-2.09,6.59,6.59,0,0,1-.24-.87h0a8.75,8.75,0,0,1,.45-5.45c3.23,2.7,6.77,6.39,11,3.6s4.37-7.91,11-7.39a10.2,10.2,0,0,1,8.41,6.12,6.75,6.75,0,0,1,7.67-1.75,6.85,6.85,0,0,1,3.88,6.89c2.75-.69,5.71-1.37,8.35-.33s4.34,4.41,2.84,6.66a1.43,1.43,0,0,1-.14.2c-1.23,1.59-3.95,2.46-3.66,4.46l.42.3,1.3.94a.05.05,0,0,1,0,0q7.65,5.52,14.9,11.6c2.48,2.08,5.12,4.58,5.29,7.83a8.64,8.64,0,0,1-.24,2.37h0c-.16.78-.38,1.56-.55,2.34a19.51,19.51,0,0,0-.34,6.05h0c.07.59.16,1.17.27,1.76,1.53,7.73,7.71,14.11,8.32,22l0,.56a17.78,17.78,0,0,1-.07,2.53c-.46,4.8-2.68,9.41-4.48,14-.11.28-.22.56-.32.84-3.47,9-5.47,18.59-7,28.16a100.26,100.26,0,0,1-2,10.09A26.73,26.73,0,0,1,611,492.07a16.22,16.22,0,0,1-3.36,3,18.67,18.67,0,0,1-2.65,1.41s0,0,0,.06c.11.61.2,1.22.31,1.83.06.32.11.64.17,1h0a.14.14,0,0,0,0,.06c.84,4.73,1.8,9.36,2.81,13.76l.51,2.19c12.6,4.55,14.09,13.87,14.18,17.44a9.64,9.64,0,0,1,0,1.43s19,.5,26.5,6a20.34,20.34,0,0,0,4.51,2.3,83,83,0,0,0,9.25,2.89c1.61.42,3.29.83,5,1.23,3,.69,6.18,1.36,9.25,2,8.19,1.65,15.9,3,19.81,4,9.33,2.36,30.67,22.82,30.67,22.82s2.5,20.64,5,23.65,7,13.59,7,13.59l16.54,29.41,7,12.37h4.5c.62,0,1.84.88,3.21,2.1,1.19,1.06,2.51,2.38,3.67,3.58l1.92,2.05,1.2,1.33s7.27.18,9.24,5.93c5.92-.17,13.19.22,18.28,2.5a14.14,14.14,0,0,1,2,1.08,8.68,8.68,0,0,1,4.13,5.66,8.34,8.34,0,0,1,.18,1.44c0,.57,0,1.14,0,1.7-.36,7.57-5.29,13.87-9.82,18.11l.32.57s-.15.36-.44,1c-.08.19-.18.4-.29.64h0c-.59,1.26-1.53,3.15-2.76,5.36a63.31,63.31,0,0,1-9.57,13.17l-.29.3-57.74.53-.17-.2L719.87,708l-5.57-6.64-.17-.21-.16,1.59-.54,5.3-1.3,12.81-.07.64,0,.17-.15,1.48.11-1.48h-.29l-107,1L429.11,724.6l0,.84h-.14l0-.84-44.75.48Z"
      transform="translate(-79.34 -172.91)"
      fill="url(#dff037aa-d578-4bab-81e7-399360663117)"
    />
    <path
      d="M617.94,550.07s-99.5,12-90,0c3.44-4.34,4.39-17.2,4.2-31.85-.06-4.45-.22-9.06-.45-13.65-1.1-22-3.75-43.5-3.75-43.5s87-41,77-8.5c-4,13.13-2.69,31.57.35,48.88.89,5.05,1.92,10,3,14.7A344.67,344.67,0,0,0,617.94,550.07Z"
      transform="translate(-79.34 -172.91)"
      fill="#fbbebe"
    />
    <path
      d="M617.94,550.07s-99.5,12-90,0c3.44-4.34,4.39-17.2,4.2-31.85,15.17-6.48,34.47-1.65,34.47-1.65,20.32-4.05,33.35-3.26,41.68-.42A344.67,344.67,0,0,0,617.94,550.07Z"
      transform="translate(-79.34 -172.91)"
      opacity="0.1"
    />
    <path
      d="M429.08,725.44l0-.84,175.62-1.91,107-1H712l-.11,1.48.15-1.48h.19l0-.17,1.37-13.45.52-5.09.16-1.59.14-1.33,6.18-20.61,6.18-20.58,5.2-17.33,7.94-26.48s-4.5-10.5-7-13.5-5-23.5-5-23.5-21.34-20.33-30.67-22.67c-3.91-1-11.63-2.33-19.83-4-3.07-.62-6.22-1.28-9.25-2-1.71-.39-3.39-.8-5-1.21a87.91,87.91,0,0,1-9.25-2.86,20.7,20.7,0,0,1-4.5-2.29c-7.35-5.39-25.77-6-26.48-6h0a.42.42,0,0,1,0-.07v-.09a10.26,10.26,0,0,0,0-1.26c0-.4,0-.87-.09-1.4,0-.16,0-.33-.07-.5-.05-.36-.11-.74-.2-1.14a5,5,0,0,0-.12-.53,17.21,17.21,0,0,0-1.25-3.49c-.07-.16-.16-.33-.24-.49a18.25,18.25,0,0,0-1.7-2.63c-.13-.17-.27-.35-.42-.52a19.58,19.58,0,0,0-2.72-2.64c-.27-.21-.55-.43-.84-.63a4.67,4.67,0,0,0-.51-.36l-.89-.58-.83-.48c-.73-.4-1.5-.79-2.34-1.16-.26-.12-.54-.23-.82-.34s-.72-.28-1.09-.42l-.06,0L608,518c-.57-.19-1.15-.36-1.76-.53l-.93-.24-1-.23-1-.21c-1-.2-2.07-.38-3.19-.52l-1.14-.14-1.17-.12-1.21-.1-1.72-.1-2-.07a124.68,124.68,0,0,0-26.24,2.79,72.27,72.27,0,0,0-18.26-1.68l-.87,0-1,.06-.64,0-1.29.12c-.43,0-.87.09-1.3.15s-.88.11-1.31.18l-.66.11c-.65.11-1.31.23-2,.37q-.33.06-.66.15c-.87.19-1.74.42-2.6.68-.43.12-.86.26-1.29.41-.22.06-.43.14-.64.22l-.64.23-.63.25-.75.3c-.38.16-.75.33-1.12.51-.21.09-.42.19-.62.3s-.41.2-.6.31a27.75,27.75,0,0,0-6.21,4.38l-.51.49-.5.51c-.17.17-.33.35-.49.53a23.82,23.82,0,0,0-1.82,2.25c-.16.21-.31.42-.46.64a26.69,26.69,0,0,0-1.72,2.92c-.13.24-.25.49-.37.73a32.7,32.7,0,0,0-2,5.25q-.28,1-.51,2S494,550.24,476.44,557c-4.67,1.8-9.07,3.43-12.75,4.66-1.07.36-2.07.69-3,1a26.7,26.7,0,0,1-6.25,1.44,19.67,19.67,0,0,0-3,.28c-8.07,1.31-21.9,7-23.41,12.71a3.69,3.69,0,0,0-.1,1.4s0,.07,0,.11c1,7-6,6-6,6s-2.5,18.5-6,23.5c-2.53,3.6-4.26,11.63-4.48,17.69v0a19.61,19.61,0,0,0,.44,5.63c0,.05,0,.1,0,.14.4,1.34-.56,5-2.19,9.69-1.77,5.15-4.35,11.55-6.83,17.59-3.74,9.12-7.26,17.4-7.48,19.22-.09.81-.35,2.26-.71,4.13-1.46,7.62-4.7,22.13-6.3,28-1.19,4.38-2.92,10.38-4.11,14.5,0,.12-.07.24-.1.35L429,724.6l0,.84h.14Z"
      transform="translate(-79.34 -172.91)"
      fill={color}
    />
    <path d="M445.44,607.57s57,29.5,77.5,26Z" transform="translate(-79.34 -172.91)" opacity="0.1" />
    <path
      d="M561.44,595.57s55.5,18,74,20.5S561.44,595.57,561.44,595.57Z"
      transform="translate(-79.34 -172.91)"
      opacity="0.1"
    />
    <path
      d="M623,537.65c-29,5.34-83.6,4.19-107.2,3.38,8.65-31,50.83-20.46,50.83-20.46C618.84,510.15,622.84,531.77,623,537.65Z"
      transform="translate(-79.34 -172.91)"
      opacity="0.1"
    />
    <path
      d="M623,535.65c-29,5.34-83.6,4.19-107.2,3.38,8.65-31,50.83-20.46,50.83-20.46C618.84,508.15,622.84,529.77,623,535.65Z"
      transform="translate(-79.34 -172.91)"
      fill={color}
    />
    <path
      d="M776.94,672.32s34.16-5.25,34.83,9.75-17.42,25.48-17.42,25.48Z"
      transform="translate(-79.34 -172.91)"
      fill="#fbbebe"
    />
    <path
      d="M605.29,501.45a47,47,0,0,1-4.5,1.74c-10.78,3.72-21.65,7.47-33,8.83s-23.26.16-33.16-5.5a28.77,28.77,0,0,1-3-1.95c-1.1-22-3.75-43.5-3.75-43.5s87-41,77-8.5C600.9,465.7,602.25,484.14,605.29,501.45Z"
      transform="translate(-79.34 -172.91)"
      opacity="0.1"
    />
    <path
      d="M552.52,364.84a9.47,9.47,0,0,1-8.32-1.75l2.08,2.89a8.47,8.47,0,0,1-6.78-2.25,34.08,34.08,0,0,0,.32,7.75,14.52,14.52,0,0,1-9.56-3,4.42,4.42,0,0,0,2.64,4.31,14.34,14.34,0,0,0-15.6,10.71l5.22.48a18.47,18.47,0,0,0-10.44,6.37c-1.6,2-2.82,4.56-2.12,7s4.08,4,5.92,2.26a27.94,27.94,0,0,0-6.1,22.79,14.47,14.47,0,0,1,.46,5.26c-.33,1.65-1.37,3.08-1.89,4.69-1,2.92-.05,6.09.84,9l4.69,15.42c1.7,5.57,3.39,11.15,5.61,16.54a82.08,82.08,0,0,1,4,10.51c1.26,4.84,1.31,10.14,4,14.37a19.93,19.93,0,0,0,7.18,6.33c9.89,5.66,21.84,6.86,33.16,5.5s22.18-5.11,32.95-8.83a31,31,0,0,0,6.84-3c7.45-4.88,9.11-14.86,10.5-23.65,1.55-9.8,3.62-19.58,7.29-28.8,2.18-5.49,5-11.06,4.52-16.94-.61-7.81-6.79-14.14-8.32-21.82a19,19,0,0,1,.07-7.77,17.66,17.66,0,0,0,.79-4.7c-.17-3.22-2.81-5.7-5.29-7.77Q609.11,380,600.52,374c-.29-2,2.43-2.86,3.66-4.44,1.74-2.23-.06-5.77-2.7-6.81s-5.6-.36-8.35.33a6.59,6.59,0,0,0-11.55-5.11,10.2,10.2,0,0,0-8.42-6.08c-6.63-.52-6.76,4.55-11,7.34s-7.74-.89-11-3.57A9.28,9.28,0,0,0,552.52,364.84Z"
      transform="translate(-79.34 -172.91)"
      fill="#3f3d56"
    />
    <path
      d="M802.27,702.32s-.89,2.12-2.53,5.19a69,69,0,0,1-9,13.17l-.27.29-1.62,0-57.74.53-1.38,0-.17-.2-11.2-13.29L714.14,703l-.17-.21-.36-.42-.2-.24-.26-.31-8.21-9.74,3-12.5,5.11-21.06.13-.51,1-4,.71-3,2.38-9.78,8.16-33.65,14.5,7.5,15.29,27,8.21,14.5h4.5c.85,0,2.8,1.64,4.76,3.53.7.67,1.4,1.38,2,2,1.78,1.84,3.19,3.42,3.19,3.42s7.29.16,9.25,5.9a7,7,0,0,1,.25.85,40.3,40.3,0,0,0,2.53,6.56c1.29,2.81,2.91,6,4.55,9.19,3.05,5.85,6.15,11.42,7.29,13.44l.14.25Z"
      transform="translate(-79.34 -172.91)"
      fill={color}
    />
    <path
      d="M716.37,657.17l-.1,1.43v.1l-.17,2.3-1.33,18.51-1.61,22.3-.46,6.28-1,13.44v.17l-107,1L429.11,724.6l0,.84h-.14l0-.84v-.28l.45-14.36.86-28.06.74-23.79.07-2.37a10.53,10.53,0,0,1,11.42-10.17c4.72.4,10.85.89,18.18,1.41l3,.22c42.33,2.94,120.56,6.74,199.5,2,1.66-.09,3.33-.19,5-.31,12.24-.77,24.47-1.76,36.58-3a10.53,10.53,0,0,1,11.6,11.23Z"
      transform="translate(-79.34 -172.91)"
      opacity="0.1"
    />
    <path
      d="M429.08,725.44l0-.84,175.62-1.91,107-1H712v-.17l1-13.44.43-6,1.64-22.61,1.29-17.9,0-.44a10.62,10.62,0,0,0-.11-2.47.3.3,0,0,0,0-.1,10.39,10.39,0,0,0-2-4.64,10.54,10.54,0,0,0-9.42-4c-12.11,1.24-24.34,2.23-36.58,3-1.67.12-3.34.22-5,.31-78.94,4.69-157.17.89-199.5-2l-3-.22c-7.33-.52-13.46-1-18.18-1.41a10.54,10.54,0,0,0-11.24,8.53,11,11,0,0,0-.18,1.64l-.68,22.16L429.54,710l-.44,14.36v.28l0,.84Z"
      transform="translate(-79.34 -172.91)"
      fill="#3f3d56"
    />
    <path
      d="M716.67,664.18l-1.23,15.33-1.83,22.85-.46,5.72-1,12.81-.06.64v.17h0l-.15,1.48.11-1.48h-.29l-107,1L429.11,724.6v-.28l.49-14.36,1-28.06.64-18.65A6.36,6.36,0,0,1,434.3,658a6.25,6.25,0,0,1,3.78-.9c2.1.17,4.68.37,7.69.59,4.89.36,10.92.78,17.94,1.22,13,.82,29.31,1.7,48,2.42,52,2,122.2,2.67,188.88-3.17,3-.26,6.1-.55,9.13-.84a6.26,6.26,0,0,1,3.48.66,5.16,5.16,0,0,1,.86.54,6.14,6.14,0,0,1,2,2.46,3.56,3.56,0,0,1,.25.61A6.28,6.28,0,0,1,716.67,664.18Z"
      transform="translate(-79.34 -172.91)"
      opacity="0.1"
    />
    <path
      d="M377.44,677.87v3.19a6.13,6.13,0,0,1-3.5,5.54l-40.1.77a6.12,6.12,0,0,1-3.57-5.57v-3Z"
      transform="translate(-79.34 -172.91)"
      opacity="0.1"
    />
    <polygon
      points="298.6 515.57 246.35 516.57 246.35 507.9 298.6 506.9 298.6 515.57"
      fill="#3f3d56"
    />
    <polygon
      points="298.6 515.57 246.35 516.57 246.35 507.9 298.6 506.9 298.6 515.57"
      opacity="0.1"
    />
    <polygon
      points="300.6 515.57 248.35 516.57 248.35 507.9 300.6 506.9 300.6 515.57"
      fill="#3f3d56"
    />
    <g opacity="0.1">
      <path
        d="M552.93,361.56a9.75,9.75,0,0,1-1.89-4.34,9.49,9.49,0,0,0,.42,4.6A9,9,0,0,0,552.93,361.56Z"
        transform="translate(-79.34 -172.91)"
      />
      <path
        d="M540.23,368.2a35.12,35.12,0,0,1-.37-3.7c0,1.23,0,2.47,0,3.71Z"
        transform="translate(-79.34 -172.91)"
      />
      <path
        d="M621.73,401.57a18.34,18.34,0,0,1,.36-2.65,18,18,0,0,0,.8-4.69,6.16,6.16,0,0,0-.16-1.06c-.17.92-.44,1.84-.64,2.75A19.14,19.14,0,0,0,621.73,401.57Z"
        transform="translate(-79.34 -172.91)"
      />
      <path
        d="M600.93,370.67l1.09.79a19.71,19.71,0,0,0,2.57-2.22,3.67,3.67,0,0,0,.38-3.64,3,3,0,0,1-.38.64C603.36,367.82,600.64,368.69,600.93,370.67Z"
        transform="translate(-79.34 -172.91)"
      />
      <path
        d="M518.76,380.29a12.32,12.32,0,0,0-.87,2.28,18.16,18.16,0,0,1,5-1.89Z"
        transform="translate(-79.34 -172.91)"
      />
      <path
        d="M532.55,369.41a14.83,14.83,0,0,1-1.88-1.23,4.25,4.25,0,0,0,.09,1.18A11.86,11.86,0,0,1,532.55,369.41Z"
        transform="translate(-79.34 -172.91)"
      />
      <path
        d="M630.32,428.33c-.41,4.85-2.67,9.52-4.5,14.12-3.67,9.22-5.74,19-7.29,28.81-1.39,8.79-3,18.77-10.5,23.64a30,30,0,0,1-6.83,3c-10.78,3.73-21.65,7.47-33,8.83s-23.26.17-33.16-5.49a20,20,0,0,1-7.18-6.33c-2.67-4.23-2.72-9.53-4-14.37a82.21,82.21,0,0,0-4-10.52c-2.21-5.38-3.91-11-5.6-16.53q-2.35-7.71-4.69-15.43a28.81,28.81,0,0,1-1.14-4.75c-.39,2.56.37,5.24,1.14,7.75q2.34,7.73,4.69,15.43c1.69,5.57,3.39,11.15,5.6,16.53a82.21,82.21,0,0,1,4,10.52c1.26,4.84,1.31,10.14,4,14.37a20,20,0,0,0,7.18,6.33c9.9,5.66,21.84,6.85,33.16,5.49s22.18-5.1,33-8.83a30,30,0,0,0,6.83-3c7.45-4.87,9.11-14.85,10.5-23.64,1.55-9.81,3.62-19.59,7.29-28.81,2.18-5.48,5-11.05,4.52-16.94C630.34,428.45,630.32,428.39,630.32,428.33Z"
        transform="translate(-79.34 -172.91)"
      />
      <path
        d="M510.63,424.46s0-.07,0-.11a14,14,0,0,0-.46-5.25,26.59,26.59,0,0,1-.39-3.32,27.35,27.35,0,0,0,.39,6.32C510.33,422.88,510.51,423.67,510.63,424.46Z"
        transform="translate(-79.34 -172.91)"
      />
      <path
        d="M513.68,400a27.74,27.74,0,0,1,2.61-3.67c-1.83,1.75-5.21.19-5.92-2.24a5.83,5.83,0,0,0,0,3A4.39,4.39,0,0,0,513.68,400Z"
        transform="translate(-79.34 -172.91)"
      />
    </g>
    <path
      d="M763.44,656.57s3.17,11.5,0,21.5S763.44,656.57,763.44,656.57Z"
      transform="translate(-79.34 -172.91)"
      opacity="0.1"
    />
    <path
      d="M776.94,668.3s1.33,14.6-1.67,17.19S776.94,668.3,776.94,668.3Z"
      transform="translate(-79.34 -172.91)"
      opacity="0.1"
    />
    <line
      x1="198.99"
      y1="342.86"
      x2="300.6"
      y2="341.86"
      fill="none"
      stroke={color}
      strokeMiterlimit="10"
      strokeWidth="2"
    />
    <line
      x1="198.99"
      y1="355.33"
      x2="300.6"
      y2="354.34"
      fill="none"
      stroke={color}
      strokeMiterlimit="10"
      strokeWidth="2"
    />
    <line
      x1="198.99"
      y1="367.81"
      x2="300.6"
      y2="366.81"
      fill="none"
      stroke={color}
      strokeMiterlimit="10"
      strokeWidth="2"
    />
  </svg>
);
